import React, { useEffect } from "react";
import TitleHeader from "../newProviderApp/component/titleHeader";
import Button from "../newProviderApp/component/button";
import { ShowAlert } from "../../common/alert";
import axios from "axios";
import LinkExpire from "../contentReaderMarkdown/linkExpire";
import DateComp from "./dateComp";
import ContentViewDob from "./viewContentDob";

const DobComp = ({ id }) => {
   const [media, setMedia] = React.useState(null);
   const [loading, setLoading] = React.useState(false);
   const [disable, setDisable] = React.useState(true);
   const [error, setError] = React.useState(false);
   const [dob, setDob] = React.useState(null);
   const verifyCode = () => {
      if (dob === null) {
         ShowAlert("Please select a date of birth !!", "error");
         return;
      }
      getSignedURl(true);
   };
   const getSignedURl = (sendCode = false) => {
      if (sendCode) {
         setLoading(true);
      }
      setDisable(true);
      let postData = {
         id: id,
      };
      if (sendCode) {
         const date = new Date(dob);
         const year = date.getFullYear();
         const month = ("0" + (date.getMonth() + 1)).slice(-2); // Add leading zero
         const day = ("0" + date.getDate()).slice(-2); // Add leading zero
         const formattedDate = `${year}${month}${day}`;
         postData.dob = formattedDate;
      }
      axios
         .post(`${process.env.REACT_APP_URL}/servercontent/${sendCode ? "dobVerify" : "validation"}`, postData)
         .then((response) => {
            const responseData = response.data;
            if (responseData.success && sendCode) {
               setMedia(responseData);
            } else if (!responseData.success) {
               ShowAlert("Invalid Date of Birth", "error");
            }
            setLoading(false);
            setDisable(false);
         })
         .catch(() => {
            setDisable(false);
            setError(true);
         });
   };

   useEffect(() => {
      getSignedURl();
      window.addEventListener("keypress", handleKeyPressEvent);
      return () => {
         window.removeEventListener("keypress", handleKeyPressEvent);
      };
   }, []);

   const handleKeyPressEvent = (event) => {
      if (event.keyCode === 13 && event.key === "Enter") {
         const btn = document.getElementById("link-verify-button-content-dob");
         if (btn) {
            btn.click();
         }
      }
   };
   return (
      <div className="h-100 w-100 flex-center px-3 ">
         {error ? (
            <div className="link-expire-cont">
               <LinkExpire />
            </div>
         ) : media ? (
            <div style={{ height: "93%" }} className="main-container-verify-shared-link-dob ">
               <div className="title-parent-dob-verify">{media?.title}</div>
               <div
                  className={`${
                     media?.type.includes("audio") || media?.type.includes("mp3")
                        ? "audio-content-bg-image-dob-verify"
                        : "flex-center "
                  } ${
                     media?.type?.includes("pdf")
                        ? "content-container-view-content-dob-link-pdf"
                        : media?.type === "text" || media?.type === "item"
                        ? "content-container-view-content-dob"
                        : "content-container-view-content-dob-link"
                  } `}
               >
                  <ContentViewDob ftype={media?.type} title={media?.title} url={media?.signedURL} />
               </div>
               {media?.comments && (
                  <div className="dc-comment-box">
                     <div className="dc-meaasge-text">Message</div>
                     <div className="dc-comment-text">{media?.comments}</div>
                  </div>
               )}
            </div>
         ) : (
            <div className=" flex-center h-100">
               <div className="main-container-verify-shared-link ">
                  <TitleHeader title={"Verify"} subtitle={"Please verify your date of birth to view this content."} />
                  <div className="mt-5 mb-4 custom-width-dob-verify">
                     <DateComp dob={dob} setDob={setDob} />
                  </div>

                  <div className="flex-center mt-5">
                     <Button
                        disabled={disable}
                        id="link-verify-button-content-dob"
                        title={loading ? "Verifying..." : "Verify"}
                        className="blue-button-new-app button-middle-section mt-5"
                        onClick={verifyCode}
                     />
                  </div>
               </div>
            </div>
         )}
      </div>
   );
};

export default DobComp;
